import { getLanguageData } from "../languageData";

export default getLanguageData("es");
